export enum EnumChatSuggestionsLayout {
  List = 'list',
  Grid = 'grid',
}
